import { render, staticRenderFns } from "./ReservationTable.vue?vue&type=template&id=7580f074&"
import script from "./ReservationTable.vue?vue&type=script&lang=js&"
export * from "./ReservationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports